















































































































































































































































































































































































































import { add, fromUnixTime, sub, isAfter, isBefore, isWithinInterval } from 'date-fns';
import axios from 'axios';
import { get, isEmpty } from 'lodash';
import EventBus from '@/eventBus';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoDate from '@/components/Molecules/co-date/CoDate.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';
import CoTag from '@/components/Atoms/co-tag/CoTag.vue';
import CoPill from '@/components/Atoms/co-pill/CoPill.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoTable from '@/components/Molecules/co-table/CoTable.vue';
import CoModal from '../co-modal/CoModal.vue';

export default {
    name: 'CoBookingModal',
    components: {
        CoModal,
        CoText,
        CoThumbnail,
        CoDate,
        CoFormGroup,
        CoLink,
        CoButton,
        CoConfirmation,
        CoTable,
        CoTag,
        CoPill,
        CoCard,
    },
    props: {
        booking: {
            type: Object,
            required: false,
            default: () => {},
        },
        asAdmin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            forUser: null, // user object for whom is booking
            byUser: null, // user object by who was it booked
            loading: false,
            lockPins: [],
            requestingLockPins: false,
            lockActionLoading: false,
            activeLockID: '',
            activeLockAction: '',
            lockAvailabilityNow: Date.now(),
            lockAvailabilityTimer: null,
        };
    },
    computed: {
        currencyChar() {
            if (!this.$store || !get(this.$store, 'state.space.Currency', '')) {
                return '€';
            }

            const currency = get(this.$store, 'state.space.Currency', '').toUpperCase();

            if (currency === 'EUR') {
                return '€';
            }
            if (currency === 'USD') {
                return '$';
            }

            return currency;
        },
        idToNames() {
            const idsnames = {};

            if (this.booking.Resource) {
                idsnames[this.booking.Resource.ID] = this.booking.Resource.Name;

                const upgrades = get(this.booking, 'Upgrades', []);
                upgrades.forEach((element) => {
                    idsnames[element.OriginalID] = element.Name;
                });
            }
            return idsnames;
        },
        totalPrice() {
            if (!this.booking) {
                return 0;
            }

            if (this.booking.Price) {
                const tmp = this.booking.Price.PriceInCentsGross ? this.booking.Price.PriceInCentsGross / 100 : 0;
                return tmp.toFixed(2);
            }
            const tmp = this.booking.PriceInCentsGross ? this.booking.PriceInCentsGross / 100 : 0;
            return tmp.toFixed(2);
        },
        bookingPricePreviewDetailed() {
            const result = {
                Items: [],
                TaxRates: [],
                Subtotal: 0,
                TaxTotal: 0,
                Total: 0,
            };

            if (!this.booking.Price || isEmpty(this.booking.Price) || !this.booking.Price.Items) {
                return null;
            }

            this.booking.Price.Items.forEach((element) => {
                const resource = {
                    name: this.idToNames[element.ResourceID],
                    quantity: element.Quantity,
                    tax: '',
                    displayprice: 0,
                    net: 0,
                    gross: 0,
                };

                const taxPercentage = element.TaxPercentage ? element.TaxPercentage : 0;
                resource.tax = `${taxPercentage}%`;
                if (element.TaxRateName) {
                    resource.tax += ` ${element.TaxRateName}`;
                }

                resource.displayprice = element.PriceInCentsBeforeCredits ? element.PriceInCentsBeforeCredits : 0;
                resource.net = element.PriceInCentsBeforeCreditsNet ? element.PriceInCentsBeforeCreditsNet : 0;
                resource.gross = element.PriceInCentsBeforeCreditsGross ? element.PriceInCentsBeforeCreditsGross : 0;

                result.Items.push(resource);

                if (element.CreditsInCents) {
                    const credits = {
                        name: `↳${this.$t('labels.credits')}`,
                        quantity: '',
                        tax: '',
                        displayprice: 0,
                        net: 0,
                        gross: 0,
                    };

                    credits.displayprice = -(element.CreditsInCents ? element.CreditsInCents : 0);
                    credits.net = -(element.CreditsInCentsNet ? element.CreditsInCentsNet : 0);
                    credits.gross = -(element.CreditsInCentsGross ? element.CreditsInCentsGross : 0);

                    result.Items.push(credits);
                }

                if (element.DiscountInCents) {
                    const discount = {
                        name: `↳${this.$t('labels.couponcode')} "${element.PromoCodeName}"`,
                        quantity: '',
                        tax: '',
                        displayprice: 0,
                        net: 0,
                        gross: 0,
                    };

                    discount.displayprice = -(element.DiscountInCents ? element.DiscountInCents : 0);
                    discount.net = -(element.DiscountInCentsNet ? element.DiscountInCentsNet : 0);
                    discount.gross = -(element.DiscountInCentsGross ? element.DiscountInCentsGross : 0);

                    result.Items.push(discount);
                }
            });

            result.Subtotal = this.booking.Price.PriceInCentsNet ? this.booking.Price.PriceInCentsNet : 0;
            result.Total = this.booking.Price.PriceInCentsGross ? this.booking.Price.PriceInCentsGross : 0;
            result.TaxTotal = result.Total - result.Subtotal;

            const taxRates = {};

            this.booking.Price.Items.forEach((element) => {
                const tax = {
                    name: element.TaxRateName,
                    quantity: '',
                    tax: `${element.TaxPercentage}%`,
                    displayprice: element.TaxInCents,
                    net: 0,
                    gross: 0,
                };

                const existingTaxRate = taxRates[`${element.TaxRateName}-${element.TaxPercentage}`];
                if (existingTaxRate) {
                    tax.displayprice += existingTaxRate.displayprice;
                }

                taxRates[`${element.TaxRateName}-${element.TaxPercentage}`] = tax;
            });

            for (const k in taxRates) {
                result.TaxRates.push(taxRates[k]);
            }
            return result;
        },
        bookingPricePreview() {
            if (!this.booking.Price) return [];

            const net = this.booking.Price.PriceInCentsNet ? this.booking.Price.PriceInCentsNet : 0;
            const gross = this.booking.Price.PriceInCentsGross ? this.booking.Price.PriceInCentsGross : 0;
            const taxamount = gross - net;
            const subtotal = {
                name: this.$t('labels.pricesubtotal'),
                amount: net,
            };

            const tax = {
                name: this.$t('labels.tax'),
                amount: taxamount,
            };

            const total = {
                name: this.$t('labels.total'),
                amount: gross,
            };

            const lines = [subtotal, tax, total];
            return lines;
        },
        creditsSummary() {
            if (!this.booking.Price || !this.booking.Price.Items) return null;

            const resourcePricePreview = this.booking.Price.Items.find(
                (item) => item.ResourceID === this.booking.ResourceID
            );
            if (!resourcePricePreview) return null;

            let used = resourcePricePreview.CreditsTimeUnitUsed ? resourcePricePreview.CreditsTimeUnitUsed : 0;
            let total = resourcePricePreview.CreditsTimeUnitTotal ? resourcePricePreview.CreditsTimeUnitTotal : 0;
            let before = resourcePricePreview.CreditsTimeUnitBeforeBooking
                ? resourcePricePreview.CreditsTimeUnitBeforeBooking
                : 0;
            let after = resourcePricePreview.CreditsTimeUnitAfterBooking
                ? resourcePricePreview.CreditsTimeUnitAfterBooking
                : 0;

            const cashCredits = resourcePricePreview.CashCredits;
            if (cashCredits) {
                used = resourcePricePreview.CashCreditsUsed ? resourcePricePreview.CashCreditsUsed : 0;
                total = resourcePricePreview.CashCreditsTotal ? resourcePricePreview.CashCreditsTotal : 0;
                before = resourcePricePreview.CashCreditsBeforeBooking
                    ? resourcePricePreview.CashCreditsBeforeBooking
                    : 0;
                after = resourcePricePreview.CashCreditsAfterBooking ? resourcePricePreview.CashCreditsAfterBooking : 0;
            }

            if (!used) {
                return null;
            }

            const res = [
                {
                    name: this.$t('labels.creditsbeforebooking'),
                    amount: before,
                },
                {
                    name: this.$t('labels.creditsused'),
                    amount: used,
                },

                {
                    name: this.$t('labels.creditsafterbooking'),
                    amount: after,
                },

                {
                    name: this.$t('labels.creditstotal'),
                    amount: total,
                },
            ];

            return {
                cashCredits,
                items: res,
            };
        },
        byUserUrl() {
            if (!this.byUser) {
                return '';
            }

            if (this.asAdmin) {
                return `/admin/community/member/view/${this.byUser.ID}`;
            }

            return `/profile/${this.byUser.Slug}`;
        },
        forUserUrl() {
            if (!this.forUser) {
                return '';
            }

            if (this.asAdmin) {
                return `/admin/community/member/view/${this.forUser.ID}`;
            }

            return `/profile/${this.forUser.Slug}`;
        },
        canCancel() {
            if (!this.booking || this.hasTerminalBookingStatus) {
                return false;
            }

            if (this.asAdmin) {
                return true;
            }

            const start = fromUnixTime(this.booking.Start);
            const cancelPeriod = start;
            const diff = sub(cancelPeriod, {
                hours: this.booking.Resource.CancellationPeriod,
            });
            let canCancel = true;
            const now = new Date();
            if (isAfter(now, diff)) {
                canCancel = false;
            }

            return canCancel;
        },
        isCanceled() {
            return this.booking?.Status === 'cancelled';
        },
        hasTerminalBookingStatus() {
            // Treat terminal booking states like an already passed booking so follow-up actions stay disabled.
            return ['cancelled', 'failed'].includes(this.booking?.Status);
        },
        bookingLocks() {
            return get(this.booking, 'Resource.Locks', []);
        },
        bookingLocksTableItems() {
            return this.bookingLocks.map((lock) => {
                const matchingPin = this.lockPins.find((pin) => pin.LockID === lock.ID);

                return {
                    id: lock.ID,
                    name: lock.Name || this.$t('labels.unknown'),
                    pin: matchingPin ? matchingPin.Code : '',
                    lock,
                };
            });
        },
        hasProvidedLockPins() {
            return this.lockPins.length > 0;
        },
        lockPin() {
            if (!this.lockPins || this.lockPins.length === 0) {
                return null;
            }

            return this.lockPins[0].Code;
        },
        isLockControlsBusy() {
            return this.requestingLockPins || this.lockActionLoading;
        },
        isLockControlsAvailable() {
            if (this.hasTerminalBookingStatus) {
                return false;
            }

            const lock = this.bookingLocks.length > 0 ? this.bookingLocks[0] : null;
            if (!lock) return false;

            const availability = this.getLockAvailability(lock);
            const now = this.getLockAvailabilityNow();

            return (
                isWithinInterval(now, {
                    start: availability.from,
                    end: availability.until,
                }) && now.getTime() !== availability.until.getTime()
            );
        },
        lockTableColumns() {
            return [
                {
                    title: this.$t('labels.name'),
                    key: 'name',
                },
                {
                    title: this.$t('labels.pin'),
                    key: 'pin',
                },
                {
                    title: this.$t('labels.actions'),
                    key: 'actions',
                },
            ];
        },
    },
    watch: {
        booking(val) {
            if (val) {
                this.$refs[`bookin-modal`].show();
            } else {
                this.$refs[`bookin-modal`].hide();
            }

            this.syncLockPins();
            this.resetLockAvailabilityRefresh();
            this.requestingLockPins = false;
            this.lockActionLoading = false;
            this.activeLockID = '';
            this.activeLockAction = '';

            if (!val) {
                return;
            }

            if (this.forUser && this.forUser === val.UserID && val.UserID !== '') {
                // skip loading again
            } else {
                this.forUser = null;
                if (val.UserID) {
                    this.getForUser(val.UserID);
                }
            }
            if (
                this.byUser &&
                this.byUser === val.UserID &&
                val.UserID !== '' &&
                this.forUser &&
                this.byUser.ID === this.forUser.ID
            ) {
                // skip loading again
            } else {
                this.byUser = null;
                if (val.CreatedByUserID) {
                    this.getByUser(val.CreatedByUserID);
                }
            }
        },
    },
    mounted() {
        if (this.booking) {
            this.$refs[`bookin-modal`].show();
            this.syncLockPins();
            this.resetLockAvailabilityRefresh();

            if (this.forUser && this.forUser === this.booking.UserID && this.booking.UserID !== '') {
                // skip loading again
            } else {
                this.forUser = null;
                if (this.booking.UserID) {
                    this.getForUser(this.booking.UserID);
                }
            }
            if (
                this.byUser &&
                this.byUser === this.booking.UserID &&
                this.booking.UserID !== '' &&
                this.forUser &&
                this.byUser.ID === this.forUser.ID
            ) {
                // skip loading again
            } else {
                this.byUser = null;
                if (this.booking.CreatedByUserID) {
                    this.getByUser(this.booking.CreatedByUserID);
                }
            }
        }
    },
    beforeDestroy() {
        this.clearLockAvailabilityRefresh();
    },
    methods: {
        get,
        syncLockPins() {
            // Keep locally rendered pins in sync with the latest booking payload while lock actions stay component-local.
            this.lockPins = get(this.booking, 'LockPins', []);
        },
        getLockAvailabilityNow() {
            return new Date(this.lockAvailabilityNow);
        },
        resetLockAvailabilityRefresh() {
            this.clearLockAvailabilityRefresh();
            this.lockAvailabilityNow = Date.now();

            if (!this.bookingLocks.length) {
                return;
            }

            // Refresh the lock availability copy automatically while the modal is open.
            this.lockAvailabilityTimer = window.setInterval(() => {
                this.lockAvailabilityNow = Date.now();
            }, 1000);
        },
        clearLockAvailabilityRefresh() {
            if (!this.lockAvailabilityTimer) {
                return;
            }

            window.clearInterval(this.lockAvailabilityTimer);
            this.lockAvailabilityTimer = null;
        },
        getBookingBaseUrl() {
            if (!this.booking) {
                return '';
            }

            if (this.asAdmin) {
                return `/admin/booking/${this.booking.ID}`;
            }

            return `/booking/${this.booking.ID}`;
        },
        getLockAvailability(lock) {
            const bookingStart = fromUnixTime(this.booking.Start);
            const bookingEnd = fromUnixTime(this.booking.End);
            const timeBefore = Number(lock.BeforeUnitXTimesBeforBookingStart) || 0;
            const timeAfter = Number(lock.AfterUnitXTimesAfterBookingEnd) || 0;

            return {
                from: sub(bookingStart, { [this.getLockTimeUnit(lock.BeforeUnit)]: timeBefore }),
                until: add(bookingEnd, { [this.getLockTimeUnit(lock.AfterUnit)]: timeAfter }),
            };
        },
        getLockTimeUnit(unit) {
            const units = ['seconds', 'minutes', 'hours', 'days', 'weeks', 'months', 'years'];

            if (typeof unit === 'number') {
                // The current resource editor sends the legacy undefined value (0) for minute windows.
                return units[unit - 1] || 'minutes';
            }

            const normalizedUnit = `${unit || ''}`.toLowerCase().replace('timeunittype_', '');
            if (!normalizedUnit) {
                return 'minutes';
            }

            return units.find((timeUnit) => timeUnit.startsWith(normalizedUnit)) || 'minutes';
        },
        getLockAvailabilityMessage(lock) {
            if (this.hasTerminalBookingStatus) {
                return this.$t('messages.booking.lockAvailabilityExpired');
            }

            const availability = this.getLockAvailability(lock);
            const now = this.getLockAvailabilityNow();
            const availableFrom = this.$t('datetime', { date: availability.from, format: 'E, PPp' });
            const availableUntilTime = this.$t('datetime', { date: availability.until, format: 'p' });

            if (isBefore(now, availability.from)) {
                const secondsUntilAvailable = Math.max(
                    0,
                    Math.ceil((availability.from.getTime() - now.getTime()) / 1000)
                );

                if (secondsUntilAvailable > 60 * 60) {
                    return this.$t('messages.booking.lockAvailabilityStartsAt', {
                        available_from: availableFrom,
                    });
                }

                return this.$t('messages.booking.lockAvailabilityCountdown', {
                    available_from: availableFrom,
                    time_until_available: this.formatLockAvailabilityCountdown(secondsUntilAvailable),
                });
            }

            if (
                isWithinInterval(now, {
                    start: availability.from,
                    end: availability.until,
                }) &&
                now.getTime() !== availability.until.getTime()
            ) {
                return this.$t('messages.booking.lockAvailabilityActiveUntil', {
                    available_until: availableUntilTime,
                });
            }

            return this.$t('messages.booking.lockAvailabilityExpired');
        },
        formatLockAvailabilityCountdown(totalSeconds) {
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            const parts = [];

            if (hours > 0) {
                parts.push(this.$tc('messages.booking.lockAvailabilityUnitHour', hours, { count: hours }));
            }
            if (minutes > 0) {
                parts.push(this.$tc('messages.booking.lockAvailabilityUnitMinute', minutes, { count: minutes }));
            }
            if (seconds > 0 || parts.length === 0) {
                parts.push(this.$tc('messages.booking.lockAvailabilityUnitSecond', seconds, { count: seconds }));
            }

            if (parts.length === 1) {
                return parts[0];
            }

            return `${parts.slice(0, -1).join(', ')} ${this.$t('labels.and')} ${parts[parts.length - 1]}`;
        },
        close() {
            this.$emit('closed');
        },
        openPriceOverviewDetails() {
            this.$refs['priceoverview'].show();
        },
        getForUser(ID) {
            this.$store
                .dispatch('adminGetUserByID', ID)
                .then((response) => {
                    this.forUser = response;
                    if (get(this.booking, 'CreatedByUserID', '') === this.forUser.ID) {
                        this.byUser = this.forUser;
                    }
                })
                .catch((error) => {});
        },
        getByUser(ID) {
            this.$store
                .dispatch('adminGetUserByID', ID)
                .then((response) => {
                    this.byUser = response;
                })
                .catch((error) => {});
        },
        requestLockPins() {
            if (!this.booking || this.hasProvidedLockPins || this.hasTerminalBookingStatus) {
                return;
            }

            this.requestingLockPins = true;

            axios
                .get(`/booking/${this.booking.ID}/lock-pins`, {
                    withCredentials: true,
                })
                .then((response) => {
                    this.lockPins = get(response, 'data.LockPins', []);
                    EventBus.$emit('INFO', { Message: this.$t('messages.booking.lockPinsRequested') });
                })
                .catch(() => {
                    EventBus.$emit('ERROR', { Message: this.$t('messages.booking.lockPinsRequestFailed') });
                })
                .finally(() => {
                    this.requestingLockPins = false;
                });
        },
        triggerLockAction(lockID, action) {
            if (!this.booking || !lockID || this.hasTerminalBookingStatus) {
                return;
            }

            this.lockActionLoading = true;
            this.activeLockID = lockID;
            this.activeLockAction = action;

            axios
                .post(
                    `/booking/${this.booking.ID}/locks/${lockID}/${action}`,
                    {},
                    {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    }
                )
                .then(() => {
                    const message =
                        action === 'lock'
                            ? this.$t('messages.booking.lockActionLockSuccess')
                            : this.$t('messages.booking.lockActionUnlockSuccess');
                    EventBus.$emit('INFO', { Message: message });
                })
                .catch(() => {
                    const message =
                        action === 'lock'
                            ? this.$t('messages.booking.lockActionLockFailed')
                            : this.$t('messages.booking.lockActionUnlockFailed');
                    EventBus.$emit('ERROR', { Message: message });
                })
                .finally(() => {
                    this.lockActionLoading = false;
                    this.activeLockID = '';
                    this.activeLockAction = '';
                });
        },
        cancelBooking() {
            let url = `/booking/${this.booking.ID}`;

            if (this.asAdmin) {
                url = `/admin/booking/${this.booking.ID}`;
            }

            this.loading = true;
            axios({
                method: 'DELETE',
                url,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.$emit('canceled');
                })
                .catch((error) => {
                    this.$emit('failed', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
